import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const countryToISO = (
  countryCode: string | undefined
): keyof typeof ISO3166Alpha3 =>
  (countryCode as ISO3166Alpha3) ?? ISO3166Alpha3.USA;
